// extracted by mini-css-extract-plugin
export var calendarView = "_ld-0";